import type { CabinState } from '../../core';

export default function CabinEffectOverlay({
  visible,
  cabin,
}: {
  visible: boolean;
  cabin: CabinState;
}) {
  return (
    <aside
      className="cabin-effect-overlay"
      data-visible={visible}
      aria-hidden={!visible}
      aria-label="Cabin climate response"
    >
      <header>
        <span>CABIN RESPONSE</span>
        <b>LOCAL ACTUATION</b>
      </header>
      <div className="cabin-effect-route" aria-hidden="true">
        <i /><i /><i /><i />
      </div>
      <div className="cabin-effect-values">
        <div>
          <small>AIRFLOW</small>
          <strong>LEVEL 1 <em>→</em> {cabin.fan}</strong>
        </div>
        <div>
          <small>THERMAL SETPOINT</small>
          <strong>22.5 <em>→</em> {cabin.temp.toFixed(1)}°C</strong>
        </div>
      </div>
      <footer><i aria-hidden="true" /> COMFORT RESPONSE APPLIED</footer>
    </aside>
  );
}
